import { createContractRequest } from './helper';
export const postAdvisories = createContractRequest({
    route: '/contract/advisories',
    method: 'post',
    source: 'data',
});
